import React from 'react';
import styles from './Progress.module.css';

export default function Progress({ value, max = 100, className = '', label, ...rest }) {
  const percentage = Math.min(100, Math.max(0, (value / max) * 100));
  return (
    <div className={`${styles.progress} ${className}`} {...rest}>
      <div className={styles.bar} style={{ width: `${percentage}%` }} />
      {label && <span className={styles.label}>{label}</span>}
    </div>
  );
}
